// @flow

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { assetUrl } from '~/src/config/routes.js';
import qs from 'qs';
import SVG from 'react-inlinesvg';
import t from '~/src/services/i18n';
import EditorPage from '~/src/containers/EditorPage';
import Modal from '~/src/components/Modal';
import './EditorLink.scss';

const searchQuery = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
  strictNullHandling: true,
});

const qsStringify = (query) => {
  // stringify normally, but respect nulls as 'defined' values
  return qs.stringify(query, { strictNullHandling: true });
};

type Props = {
  onClick: Function,
  history: Object,
};

function EditorLink(props: Props) {
  const [shown, setShown] = useState('editor' in searchQuery);

  useEffect(() => {
    if (document.body) {
      if (!shown) {
        document.body.classList.remove('modal-open');
        delete searchQuery.editor;
        props.history.push({ search: qsStringify(searchQuery) });
      } else {
        document.body.classList.add('modal-open');
        searchQuery.editor = null; // this will give us simply `?editor`
        props.history.push({ search: qsStringify(searchQuery) });
      }
    }
    return function unmount() {
      if (document.body) {
        document.body.classList.remove('modal-open');
      }
    };
  }, [shown]);

  return (
    <div className="editor-link">
      <Link
        to="/editor"
        className="btn btn-secondary btn-icon btn-edit"
        onClick={(e) => {
          e.preventDefault();
          props.onClick();
          setShown(true);
        }}
      >
        {t('tryIt')}
      </Link>

      {shown && (
        <Modal className="editor-modal">
          <div className="editor-modal-header">
            <div className="title">{t('Product Gallery Demo')}</div>
            <button
              className="btn btn-icon btn-close"
              onClick={() => {
                if (document.body) {
                  document.body.classList.remove('modal-open');
                }
                setShown(false);
              }}
            >
              <SVG src={assetUrl('Icons/close.svg')} />
            </button>
          </div>
          <EditorPage />
        </Modal>
      )}
    </div>
  );
}

export default withRouter(EditorLink);
